import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialTableCopyDataState } from "./initializes";
import type { TableCopyData, CopyDataType, EditHistoryType } from "./types";

const tableCopyDataSlice = createSlice({
  name: "TableCopyData",
  initialState: initialTableCopyDataState,
  reducers: {
    setCopyData: (state: TableCopyData, action: PayloadAction<CopyDataType>) => {
      state.copyData = action.payload;
    },
    setEditHistory: (state: TableCopyData, action: PayloadAction<EditHistoryType>) => {
      state.editHistory =
        state.editHistory.length < 50
          ? [...state.editHistory, action.payload]
          : [...state.editHistory.slice(1), action.payload];
    },
    setPrevEditHistory: (state: TableCopyData, action: PayloadAction<EditHistoryType[]>) => {
      state.editHistory = action.payload;
    },
  },
});

export const { setCopyData, setEditHistory, setPrevEditHistory } = tableCopyDataSlice.actions;

export default tableCopyDataSlice.reducer;
